import Link from 'next/link'
import { cn } from '@/lib/utils'

export function Logo({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <Link
      href="/"
      onClick={onClick}
      className={cn('group inline-flex items-baseline gap-0.5 font-display font-extrabold tracking-tight', className)}
      aria-label="NEİZLESEM ana sayfa"
    >
      <span className="text-white">NE</span>
      <span className="text-crimson-500 transition-colors group-hover:text-crimson-400">İZLESEM</span>
      <span className="text-crimson-500">?</span>
    </Link>
  )
}
